'use strict';

document.addEventListener('DOMContentLoaded', () => {

    const trigger = document.getElementById('audioeye-trigger');
    if (!trigger) {
        return;
    }

    trigger.addEventListener('click', () => {
        const audioEye = window.AudioEye;

        if (!audioEye) {
            return;
        }

        const isActive = !!(audioEye.toolbar && audioEye.toolbar.active);
        audioEye[isActive ? 'deactivate' : 'activate']('toolbar');
    });
});
